import React, { useState } from 'react'
import { useFetchAllProjectSites } from '../../../../services/FetchProjects';
import { useLocation } from 'react-router-dom';
import { Box, Card, Divider, Typography } from '@mui/material';
import { ChartComponent } from '../../../common/chartComponent';
import Grid from '@mui/material/Grid2'
import { getProjectByName } from '../../../../utils/mergeData';
import { SiteCard } from '../../../common/detailComponent';


const BiodiversityCreditDetail = () => {
  const location = useLocation();
  const siteData = location.state;
  const selectedProjectStr = localStorage.getItem('selectedProject');
  const selectedProject = selectedProjectStr ? JSON.parse(selectedProjectStr) : null;
  const currentProject = getProjectByName(selectedProject?.project_name);

  // Prioritize site-level credits if available in state, otherwise use project-level credits
  const filterSpeciesData = siteData?.biodiversity_credits || currentProject?.biodiversity_credits || [];

  const chartData1 = [
    { name: 'July 2023', value1: filterSpeciesData?.[0]?.historical_credits_retirement?.[0]?.["July 2023"] || 0 },
    { name: 'October 2023', value1: filterSpeciesData?.[0]?.historical_credits_retirement?.[0]?.["October 2023"] || 0 },
    { name: 'December 2023', value1: filterSpeciesData?.[0]?.historical_credits_retirement?.[0]?.["December 2023"] || 0 },
    { name: 'February 2024', value1: filterSpeciesData?.[0]?.historical_credits_retirement?.[0]?.["February 2024"] || 0 },
    { name: 'August 2024', value1: filterSpeciesData?.[0]?.historical_credits_retirement?.[0]?.["August 2024"] || 0 },
  ];

  const chartData2 = [
    { name: 'Retired Credits', value1: filterSpeciesData?.[0]?.["overall_issued/retired"]?.[0]?.retired || 0 },
    { name: 'Issued Credits', value1: filterSpeciesData?.[0]?.["overall_issued/retired"]?.[0]?.issued || 0 },
  ]
  return (
    <Box sx={{ mt: 5 }}>
      <Box
        sx={{
          maxHeight: '400px',
          overflowY: 'auto',
          border: '1px solid #ccc',
          padding: '10px',
          backgroundColor: "#fff",
          margin: "15px 1px",
          borderRadius: "8px",
          boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.1019607843) !important",
        }}
      >
        <Grid container spacing={4} sx={{ m: 3 }}>
          <Grid size={{ xs: 4, sm: 2 }}>
            <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
              {'Total Credits'}
            </Typography>
            <Typography sx={{ color: "#000", fontWeight: 600, fontSize: '20px' }}>
              {filterSpeciesData?.[0]?.total_credits_over_crediting_period || 0}
            </Typography>
          </Grid>
          <Divider orientation="vertical" flexItem sx={{ mx: 2, borderColor: '#ccc' }} />
          <Grid size={{ xs: 4, sm: 3 }}>
            <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
              {'Average Price Per Credit'}
            </Typography>
            <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
              {filterSpeciesData?.[0]?.average_price_per_credit || "N/A"}
            </Typography>
          </Grid>
          <Divider orientation="vertical" flexItem sx={{ mx: 2, borderColor: '#ccc' }} />
          <Grid size={{ xs: 4, sm: 3 }}>
            <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
              {'Credits Available For Sale'}
            </Typography>
            <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
              {filterSpeciesData?.[0]?.credits_available_for_sale || 0}
            </Typography>
          </Grid>
          <Divider orientation="vertical" flexItem sx={{ mx: 2, borderColor: '#ccc' }} />
          <Grid size={{ xs: 4, sm: 2 }}>
            <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
              {'Credits Retired'}
            </Typography>
            <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
              {filterSpeciesData?.[0]?.credit_retired || 0}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ mt: 1 }}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12 }}>
            <ChartComponent chartType={'column'} chartTitle={'Historical Credits Retirement'} data={chartData1} title='Credit Retired' seriesValue1='Credits' yTitle='Month Year' />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <ChartComponent chartType={'donut'} chartTitle={'Overall Issued/Retired Credits'} data={chartData2} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default BiodiversityCreditDetail